import LockIcon from '@mui/icons-material/Lock';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorState from './ErrorState';

interface PermissionStateProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

const PermissionState = ({ title, description, actions }: PermissionStateProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('visual.permissionState.title');
  const resolvedDescription = description ?? t('visual.permissionState.description');

  return (
    <ErrorState
      title={resolvedTitle}
      description={resolvedDescription}
      actions={actions}
      icon={<LockIcon color="error" />}
    />
  );
};

export default PermissionState;
